// src/components/layout/Header/FunctionalLayer/SettingsLangSelector.jsx

'use client';

import { useState } from 'react';
import { usePathname, useSearchParams, useRouter } from 'next/navigation';
import { Button, Menu, MenuItem, ListItemText } from '@mui/material';
import { Language as LanguageIcon, ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';
import { i18n } from '@/../i18n-config';


const languageNames = {
  EN: 'English',
  ES: 'Español',
  FR: 'Français',
  IT: 'Italiano'
};


export default function SettingsLangSelector() {

  const [anchorEl, setAnchorEl] = useState(null);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const createLangLink = (lang) => {
    const segments = pathname.split('/');
    segments[1] = lang;
    const newPath = segments.join('/');
    const queryString = searchParams.toString();
    return `${newPath}${queryString ? `?${queryString}` : ''}`;
  };

  const handleLanguageSelect = (lang) => {
    router.push(createLangLink(lang));
    handleClose();
  };

  const currentLang = pathname.split('/')[1].toUpperCase();

  return (
    <>
      <Button
        aria-label="Language selection"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        startIcon={<LanguageIcon />}
        endIcon={<ArrowDropDownIcon />}
      >
        {currentLang}
      </Button>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'language-button',
        }}
      >
        {i18n.locales.map((lang) => (
          <MenuItem key={lang} onClick={() => handleLanguageSelect(lang)}>
            {/*<ListItemIcon> IF I WANT TO ADD AN ICON TO EVERY LANG*/}
            {/*  <LanguageIcon fontSize="small" />*/}
            {/*</ListItemIcon>*/}
            <ListItemText>{languageNames[lang.toUpperCase()]}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
